import axios, { AxiosResponse } from 'axios';
import { createRequestConfig } from './utils';
import DeviceTrouble from '../models/data/DeviceTrouble';
import DeviceTroubleRequest, {
  DeviceTroubleDetailRequest,
} from '../models/requests/GetDeviceTrouble';

// 機器故障情報の取得関数
export default function requestDeviceTroubleList(
  url: string,
  params?: DeviceTroubleRequest,
): Promise<AxiosResponse<DeviceTrouble[]>> {
  const config = createRequestConfig({ params });
  return axios.get<DeviceTrouble[]>(url, config);
}

// 機器故障情報件数の取得関数
export function requestCountDeviceTrouble(
  url: string,
  params?: DeviceTroubleRequest,
): Promise<AxiosResponse<number>> {
  const config = createRequestConfig({ params });
  return axios.get<number>(url, config);
}

// 機器故障の詳細情報の取得関数
export function requestDeviceTroubleDetail(
  url: string,
  params?: DeviceTroubleDetailRequest,
): Promise<AxiosResponse<DeviceTrouble>> {
  const config = createRequestConfig({ params });
  return axios.get<DeviceTrouble>(url, config);
}
